var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('inputs',{attrs:{"title":_vm.title,"type":_vm.type,"barcode":_vm.barcode,"fabrics":_vm.fabrics}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }